import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { newsItems } from '../../data/newsItems';
import { 
  NewsGrid, 
  NewsCard, 
  NewsImageContainer, 
  NewsImage, 
  NewsContent,
  NewsDate, 
  NewsHeadline, 
  NewsSummary, 
  NewsLink,
  cardVariants
} from './styles/NewsTabStyles';

// Import shared styled components
import { TabContainer, Section } from '../shared/TabStyles';

const NewsTab = () => {
  return (
    <TabContainer>
      <Section>
        <h2>List of useful AI resources</h2>
        <p>Stay up-to-date with the latest developments in the AI world.</p>
        
        <AnimatePresence>
          <NewsGrid>
            {[...newsItems].reverse().map((item, index) => (
              <motion.div
                key={item.id}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
                whileHover="hover"
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                <NewsCard>
                  <NewsImageContainer>
                    <NewsImage src={item.image} alt={item.headline} />
                  </NewsImageContainer>
                  <NewsContent>
                    <NewsDate>{item.date}</NewsDate>
                    <NewsHeadline>{item.headline}</NewsHeadline>
                    <NewsSummary>{item.summary}</NewsSummary>
                    <NewsLink href={item.url} target="_blank" rel="noopener noreferrer">
                      Read More <span>&rarr;</span>
                    </NewsLink>
                  </NewsContent>
                </NewsCard>
              </motion.div>
            ))}
          </NewsGrid>
        </AnimatePresence>
      </Section>
    </TabContainer>
  );
};

export default NewsTab; 